/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getDeck = /* GraphQL */ `query GetDeck($userAlias: String, $deck_id: String!) {
  getDeck(userAlias: $userAlias, deck_id: $deck_id) {
    pk
    sk
    deckGSI_pk
    deckGSI_sk
    deck_name
    created_date
    last_updated_date
    created_by
    last_updated_by
    current_user
    locked_by
    locked_at
    lock_expiry
    publish_status
    publish_user
    publish_deck_cycle
    has_active_system_run
    last_publish_date
    publish_timestamp
    deck_cycle
    enabled_page_grains
    enabled_datasets
    __typename
  }
}
` as GeneratedQuery<APITypes.GetDeckQueryVariables, APITypes.GetDeckQuery>;
export const getLockedPagesForDeck = /* GraphQL */ `query GetLockedPagesForDeck($deck_id: String!, $userAlias: String) {
  getLockedPagesForDeck(deck_id: $deck_id, userAlias: $userAlias) {
    deck_id
    page_name
    locked_by
    locked_at
    lock_expiry
    lock_scope
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLockedPagesForDeckQueryVariables,
  APITypes.GetLockedPagesForDeckQuery
>;
export const getAllDecks = /* GraphQL */ `query GetAllDecks($userAlias: String) {
  getAllDecks(userAlias: $userAlias) {
    pk
    sk
    deckGSI_pk
    deckGSI_sk
    deck_name
    created_date
    last_updated_date
    created_by
    last_updated_by
    current_user
    locked_by
    locked_at
    lock_expiry
    publish_status
    publish_user
    publish_deck_cycle
    has_active_system_run
    last_publish_date
    publish_timestamp
    deck_cycle
    enabled_page_grains
    enabled_datasets
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAllDecksQueryVariables,
  APITypes.GetAllDecksQuery
>;
export const getTOCEntry = /* GraphQL */ `query GetTOCEntry($userAlias: String, $deck_id: String!, $toc_id: String!) {
  getTOCEntry(userAlias: $userAlias, deck_id: $deck_id, toc_id: $toc_id) {
    pk
    sk
    toc_id
    page_id
    page_no
    toc_page_name
    page_name
    is_visible
    is_active
    group_name
    serial_no
    created_date
    last_updated_date
    schedule_type
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTOCEntryQueryVariables,
  APITypes.GetTOCEntryQuery
>;
export const getAllTOCEntriesForaDeck = /* GraphQL */ `query GetAllTOCEntriesForaDeck($userAlias: String, $deck_id: String!) {
  getAllTOCEntriesForaDeck(userAlias: $userAlias, deck_id: $deck_id) {
    pk
    sk
    toc_id
    page_id
    page_no
    toc_page_name
    page_name
    is_visible
    is_active
    group_name
    serial_no
    created_date
    last_updated_date
    schedule_type
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAllTOCEntriesForaDeckQueryVariables,
  APITypes.GetAllTOCEntriesForaDeckQuery
>;
export const getTOCEntriesForaDeckByPageStatus = /* GraphQL */ `query GetTOCEntriesForaDeckByPageStatus(
  $userAlias: String
  $deck_id: String!
  $is_active: Boolean!
) {
  getTOCEntriesForaDeckByPageStatus(
    userAlias: $userAlias
    deck_id: $deck_id
    is_active: $is_active
  ) {
    pk
    sk
    toc_id
    page_id
    page_no
    toc_page_name
    page_name
    is_visible
    is_active
    group_name
    serial_no
    created_date
    last_updated_date
    schedule_type
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTOCEntriesForaDeckByPageStatusQueryVariables,
  APITypes.GetTOCEntriesForaDeckByPageStatusQuery
>;
export const getActiveTOCEntriesByScheduleType = /* GraphQL */ `query GetActiveTOCEntriesByScheduleType(
  $userAlias: String
  $deck_id: String!
  $is_active: Boolean!
  $schedule_type: ScheduleType!
) {
  getActiveTOCEntriesByScheduleType(
    userAlias: $userAlias
    deck_id: $deck_id
    is_active: $is_active
    schedule_type: $schedule_type
  ) {
    pk
    sk
    toc_id
    page_id
    page_no
    toc_page_name
    page_name
    is_visible
    is_active
    group_name
    serial_no
    created_date
    last_updated_date
    schedule_type
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetActiveTOCEntriesByScheduleTypeQueryVariables,
  APITypes.GetActiveTOCEntriesByScheduleTypeQuery
>;
export const getAllScenarioManagementEntriesForaDeck = /* GraphQL */ `query GetAllScenarioManagementEntriesForaDeck(
  $userAlias: String
  $deck_id: String!
) {
  getAllScenarioManagementEntriesForaDeck(
    userAlias: $userAlias
    deck_id: $deck_id
  ) {
    pk
    sk
    scenario_id
    deck_cycle
    month
    page_name
    page_no
    sno
    is_external_page
    page_grain
    schedule_type
    last_updated_date
    is_supplemental
    is_blankpage
    toc_sno
    toc_page_no
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAllScenarioManagementEntriesForaDeckQueryVariables,
  APITypes.GetAllScenarioManagementEntriesForaDeckQuery
>;
export const getScenarioManagementEntriesByScheduleType = /* GraphQL */ `query GetScenarioManagementEntriesByScheduleType(
  $userAlias: String
  $deck_id: String!
  $schedule_type: ScheduleType!
) {
  getScenarioManagementEntriesByScheduleType(
    userAlias: $userAlias
    deck_id: $deck_id
    schedule_type: $schedule_type
  ) {
    pk
    sk
    scenario_id
    deck_cycle
    month
    page_name
    page_no
    sno
    is_external_page
    page_grain
    schedule_type
    last_updated_date
    is_supplemental
    is_blankpage
    toc_sno
    toc_page_no
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetScenarioManagementEntriesByScheduleTypeQueryVariables,
  APITypes.GetScenarioManagementEntriesByScheduleTypeQuery
>;
export const getPage = /* GraphQL */ `query GetPage($userAlias: String, $page_id: String!) {
  getPage(userAlias: $userAlias, page_id: $page_id) {
    pk
    sk
    pageGSI_pk
    pageGSI_sk
    page_name
    deck_id
    page_grain
    page_no
    page_drivers {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    previous_page_id
    next_page_id
    page_type
    denominator_label
    denominator_drivers {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    scale
    locked_by
    locked_at
    lock_expiry
    layout_family
    report_header
    __typename
  }
}` as GeneratedQuery<APITypes.GetPageQueryVariables, APITypes.GetPageQuery>;
export const getDecklines = /* GraphQL */ `query GetDecklines($userAlias: String, $page_id: String!) {
  getDecklines(userAlias: $userAlias, page_id: $page_id) {
    calc_members {
      dimension
      tokens {
        kind
        value
        __typename
      }
      pins {
        dimension
        node
        __typename
      }
      __typename
    }
    pk
    sk
    page_name
    kpi_id
    kpi_id_by_override {
      override_set {
        datasetSource
        account_hierarchy
        account
        location_hierarchy
        location
        project_hierarchy
        project
        company_hierarchy
        company
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costcenter_hierarchy
        costcenter
        costtype
        costpool
        fieldtype
        __typename
      }
      kpi_id
      __typename
    }
    kpi_name
    kpi_formula
    serial_no
    is_code_or_description
    is_format_bold
    is_format_italics
    is_format_underline
    format_text_color
    format_cell_color
    format_cell_default
    format_cell_overrides {
      colKey
      format
      __typename
    }
    blankline_type
    is_format_borderline
    footnotes
    subtotal_formula
    subtotal_parent
    is_calculated_kpi
    kpi_type
    deckline_kind
    deckline_drivers {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    is_exception
    page_section
    column_template
    adjcalcflag
    exceptioncalculatedkpiflag
    bordertopflag
    borderrightflag
    borderbottomflag
    borderleftflag
    borderweightflag
    textunderlineflag
    denominator_kpi_id_for_pct
    denominator_kpi_id_drivers {
      datasetSource
      account_hierarchy
      account
      location_hierarchy
      location
      project_hierarchy
      project
      company_hierarchy
      company
      product_hierarchy
      product
      revgp_hierarchy
      revgp
      datasource_hierarchy
      datasource
      channel_hierarchy
      channel
      costcenter_hierarchy
      costcenter
      costtype
      costpool
      fieldtype
      __typename
    }
    denominator_kpi_type
    denominator_is_calculated_kpi
    denominator_kpi_formula
    root_kpi_id
    kpi_variant_id
    display_name
    denominator_root_kpi_id
    denominator_kpi_variant_id
    measure
    kpi_name_indent_level
    fxinclflag
    calcdivisionflag
    bps_override_flag
    comments {
      commentId
      user
      commentDesc
      timestamp
      __typename
    }
    __typename
  }
}` as GeneratedQuery<
  APITypes.GetDecklinesQueryVariables,
  APITypes.GetDecklinesQuery
>;
export const getKPI = /* GraphQL */ `query GetKPI($userAlias: String, $kpi_id: String!) {
  getKPI(userAlias: $userAlias, kpi_id: $kpi_id) {
    pk
    sk
    is_calculated_kpi
    kpi_type
    kpi_formula
    kpi_map {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    last_updated_date
    __typename
  }
}` as GeneratedQuery<APITypes.GetKPIQueryVariables, APITypes.GetKPIQuery>;
export const getFootnoteForPage = /* GraphQL */ `query GetFootnoteForPage(
  $userAlias: String
  $page_id: String!
  $footnote_id: String
) {
  getFootnoteForPage(
    userAlias: $userAlias
    page_id: $page_id
    footnote_id: $footnote_id
  ) {
    pk
    sk
    footnote_no
    footnote_description
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFootnoteForPageQueryVariables,
  APITypes.GetFootnoteForPageQuery
>;
export const getAuditHistoryForPage = /* GraphQL */ `query GetAuditHistoryForPage(
  $userAlias: String
  $deck_id: String!
  $page_id: String!
  $limit: Int
  $nextToken: String
) {
  getAuditHistoryForPage(
    userAlias: $userAlias
    deck_id: $deck_id
    page_id: $page_id
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      pk
      sk
      change_type
      before
      after
      user
      dateTime
      row
      page_name
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAuditHistoryForPageQueryVariables,
  APITypes.GetAuditHistoryForPageQuery
>;
export const getAuditHistoryForDeck = /* GraphQL */ `query GetAuditHistoryForDeck($userAlias: String, $deck_id: String!) {
  getAuditHistoryForDeck(userAlias: $userAlias, deck_id: $deck_id) {
    pk
    sk
    change_type
    before
    after
    user
    dateTime
    row
    page_name
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAuditHistoryForDeckQueryVariables,
  APITypes.GetAuditHistoryForDeckQuery
>;
export const getAllKPIs = /* GraphQL */ `query GetAllKPIs($userAlias: String, $deck_id: String, $publish_timestamp: String, $kpi_type: KPIType, $limit: Int, $nextToken: String) {
  getAllKPIs(
    userAlias: $userAlias
    deck_id: $deck_id
    publish_timestamp: $publish_timestamp
    kpi_type: $kpi_type
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      pk
      sk
      is_calculated_kpi
      kpi_type
      kpi_formula
      kpi_map {
        datasetSource
        company_hierarchy
        company
        costcenter_hierarchy
        costcenter
        costtype
        fieldtype
        location_hierarchy
        location
        ... on GalaxyKPIDrivers {
          account_hierarchy
          account
          project_hierarchy
          project
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costpool
        }
        ... on HctrKPIDrivers {
          measure_hierarchy
          measure
          transferDirection_hierarchy
          transferDirection
          workflow_hierarchy
          workflow
        }
        __typename
      }
      last_updated_date
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<
  APITypes.GetAllKPIsQueryVariables,
  APITypes.GetAllKPIsQuery
>;
export const getKPIUpdatesForDeck = /* GraphQL */ `query GetKPIUpdatesForDeck($userAlias: String!, $deck_id: String!, $publish_timestamp: String!, $kpi_type: KPIType, $nextToken: String) {
  getKPIUpdatesForDeck(
    userAlias: $userAlias
    deck_id: $deck_id
    publish_timestamp: $publish_timestamp
    kpi_type: $kpi_type
    nextToken: $nextToken
  ) {
    items {
      pk
      sk
      is_calculated_kpi
      kpi_type
      kpi_formula
      kpi_map {
        datasetSource
        company_hierarchy
        company
        costcenter_hierarchy
        costcenter
        costtype
        fieldtype
        location_hierarchy
        location
        ... on GalaxyKPIDrivers {
          account_hierarchy
          account
          project_hierarchy
          project
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costpool
        }
        ... on HctrKPIDrivers {
          measure_hierarchy
          measure
          transferDirection_hierarchy
          transferDirection
          workflow_hierarchy
          workflow
        }
        __typename
      }
      last_updated_date
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<
  APITypes.GetKPIUpdatesForDeckQueryVariables,
  APITypes.GetKPIUpdatesForDeckQuery
>;
export const getPagesByPageName = /* GraphQL */ `query GetPagesByPageName($userAlias: String, $page_name: String!, $page_grain: String, $deck_id: String) {
  getPagesByPageName(
    userAlias: $userAlias
    page_name: $page_name
    page_grain: $page_grain
    deck_id: $deck_id
  ) {
    pk
    sk
    pageGSI_pk
    pageGSI_sk
    page_name
    deck_id
    page_grain
    page_no
    page_drivers {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    previous_page_id
    next_page_id
    page_type
    denominator_label
    denominator_drivers {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    scale
    locked_by
    locked_at
    lock_expiry
    layout_family
    report_header
    __typename
  }
}` as GeneratedQuery<
  APITypes.GetPagesByPageNameQueryVariables,
  APITypes.GetPagesByPageNameQuery
>;
export const getPagesByDeck = /* GraphQL */ `query GetPagesByDeck($userAlias: String, $deck_id: String!) {
  getPagesByDeck(userAlias: $userAlias, deck_id: $deck_id) {
    pk
    sk
    pageGSI_pk
    pageGSI_sk
    page_name
    deck_id
    page_grain
    page_no
    page_drivers {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    previous_page_id
    next_page_id
    page_type
    denominator_label
    denominator_drivers {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    scale
    locked_by
    locked_at
    lock_expiry
    layout_family
    report_header
    __typename
  }
}` as GeneratedQuery<
  APITypes.GetPagesByDeckQueryVariables,
  APITypes.GetPagesByDeckQuery
>;
export const getRootKPIs = /* GraphQL */ `query GetRootKPIs($userAlias: String, $root_kpi_id: String, $nextToken: String) {
  getRootKPIs(
    userAlias: $userAlias
    root_kpi_id: $root_kpi_id
    nextToken: $nextToken
  ) {
    items {
      pk
      sk
      root_kpi_id
      root_kpi_name
      kpi_type
      variants {
        pk
        sk
        kpi_variant_id
        variant_name
        variant_overrides {
          datasetSource
          company_hierarchy
          company
          costcenter_hierarchy
          costcenter
          costtype
          fieldtype
          location_hierarchy
          location
          ... on GalaxyKPIDrivers {
            account_hierarchy
            account
            project_hierarchy
            project
            product_hierarchy
            product
            revgp_hierarchy
            revgp
            datasource_hierarchy
            datasource
            channel_hierarchy
            channel
            costpool
          }
          ... on HctrKPIDrivers {
            measure_hierarchy
            measure
            transferDirection_hierarchy
            transferDirection
            workflow_hierarchy
            workflow
          }
          __typename
        }
        dataset_source
        kpi_type
        root_kpi_id
        created_date
        last_updated_date
        created_by
        last_updated_by
        __typename
      }
      created_date
      created_by
      last_updated_date
      last_updated_by
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<
  APITypes.GetRootKPIsQueryVariables,
  APITypes.GetRootKPIsQuery
>;
export const getVariantsForRootKPI = /* GraphQL */ `query GetVariantsForRootKPI($userAlias: String, $root_kpi_id: String!) {
  getVariantsForRootKPI(userAlias: $userAlias, root_kpi_id: $root_kpi_id) {
    pk
    sk
    kpi_variant_id
    variant_name
    variant_overrides {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    dataset_source
    kpi_type
    root_kpi_id
    created_date
    last_updated_date
    created_by
    last_updated_by
    __typename
  }
}` as GeneratedQuery<
  APITypes.GetVariantsForRootKPIQueryVariables,
  APITypes.GetVariantsForRootKPIQuery
>;
export const getKPIVariant = /* GraphQL */ `query GetKPIVariant($userAlias: String, $root_kpi_id: String!, $kpi_variant_id: String!) {
  getKPIVariant(
    userAlias: $userAlias
    root_kpi_id: $root_kpi_id
    kpi_variant_id: $kpi_variant_id
  ) {
    pk
    sk
    kpi_variant_id
    variant_name
    variant_overrides {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    dataset_source
    kpi_type
    root_kpi_id
    created_date
    last_updated_date
    created_by
    last_updated_by
    __typename
  }
}` as GeneratedQuery<
  APITypes.GetKPIVariantQueryVariables,
  APITypes.GetKPIVariantQuery
>;
export const getRootKPIUsageSummary = /* GraphQL */ `query GetRootKPIUsageSummary($userAlias: String, $root_kpi_id: String!) {
  getRootKPIUsageSummary(userAlias: $userAlias, root_kpi_id: $root_kpi_id) {
    root_kpi_id
    root_kpi_name
    total_deckline_count
    total_page_count
    total_core_page_count
    total_deck_count
    deck_usage {
      deck_id
      deck_name
      page_usage {
        core_page_name
        pages {
          page_id
          page_name
          deckline_count
          kpi_variant_ids
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRootKPIUsageSummaryQueryVariables,
  APITypes.GetRootKPIUsageSummaryQuery
>;
export const getVariantUsageSummary = /* GraphQL */ `query GetVariantUsageSummary($userAlias: String, $kpi_variant_id: String!) {
  getVariantUsageSummary(
    userAlias: $userAlias
    kpi_variant_id: $kpi_variant_id
  ) {
    root_kpi_id
    root_kpi_name
    total_deckline_count
    total_page_count
    total_core_page_count
    total_deck_count
    deck_usage {
      deck_id
      deck_name
      page_usage {
        core_page_name
        pages {
          page_id
          page_name
          deckline_count
          kpi_variant_ids
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetVariantUsageSummaryQueryVariables,
  APITypes.GetVariantUsageSummaryQuery
>;
export const getKPIHierarchyAuditHistory = /* GraphQL */ `query GetKPIHierarchyAuditHistory(
  $userAlias: String
  $entities: [KPIHierarchyAuditEntityInput]
  $limit: Int
  $nextToken: String
) {
  getKPIHierarchyAuditHistory(
    userAlias: $userAlias
    entities: $entities
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      pk
      sk
      change_type
      before
      after
      user
      dateTime
      row
      page_name
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetKPIHierarchyAuditHistoryQueryVariables,
  APITypes.GetKPIHierarchyAuditHistoryQuery
>;
export const getPageLayout = /* GraphQL */ `query GetPageLayout($userAlias: String, $page_id: String!, $resolve_periods: Boolean, $rowMeasures: [String], $deck_cycle: String, $publish_year: String, $as_of_date: String) {
  getPageLayout(
    userAlias: $userAlias
    page_id: $page_id
    resolve_periods: $resolve_periods
    rowMeasures: $rowMeasures
    deck_cycle: $deck_cycle
    publish_year: $publish_year
    as_of_date: $as_of_date
  ) {
    pageId
    sections {
      sectionId
      label
      columnHeaderTree {
        ... on GroupNode {
          nodeId
          kind
          label
          footnotes
          children {
            nodeId
            kind
            label
            footnotes
            blockId
            measure
            scenario
            periodToken
            timeGrain
            nonMaterial
            dimensionOverrides {
              datasetSource
              account_hierarchy
              account
              location_hierarchy
              location
              project_hierarchy
              project
              company_hierarchy
              company
              product_hierarchy
              product
              revgp_hierarchy
              revgp
              datasource_hierarchy
              datasource
              channel_hierarchy
              channel
              costcenter_hierarchy
              costcenter
              costtype
              costpool
              fieldtype
              __typename
            }
            datasetSource
            resolvedScenario
            resolvedPeriod
            scenarioPlacement
            periodPlacement
            periodOwnedByLeaves
            bandPeriod
            children {
              nodeId
              kind
              label
              footnotes
              columnNo
              measure
              scenario
              periodToken
              timeGrain
              dimensionOverrides {
                datasetSource
                account_hierarchy
                account
                location_hierarchy
                location
                project_hierarchy
                project
                company_hierarchy
                company
                product_hierarchy
                product
                revgp_hierarchy
                revgp
                datasource_hierarchy
                datasource
                channel_hierarchy
                channel
                costcenter_hierarchy
                costcenter
                costtype
                costpool
                fieldtype
                __typename
              }
              format {
                cellDefault
                __typename
              }
              calculation {
                type
                operands
                __typename
              }
              colKey
              excelLetter
              resolvedScenario
              resolvedPeriod
              __typename
            }
            __typename
          }
          __typename
        }
        ... on BlockNode {
          nodeId
          kind
          label
          footnotes
          blockId
          measure
          scenario
          periodToken
          timeGrain
          nonMaterial
          dimensionOverrides {
            datasetSource
            account_hierarchy
            account
            location_hierarchy
            location
            project_hierarchy
            project
            company_hierarchy
            company
            product_hierarchy
            product
            revgp_hierarchy
            revgp
            datasource_hierarchy
            datasource
            channel_hierarchy
            channel
            costcenter_hierarchy
            costcenter
            costtype
            costpool
            fieldtype
            __typename
          }
          datasetSource
          resolvedScenario
          resolvedPeriod
          scenarioPlacement
          periodPlacement
          periodOwnedByLeaves
          bandPeriod
          children {
            nodeId
            kind
            label
            footnotes
            columnNo
            measure
            scenario
            periodToken
            timeGrain
            dimensionOverrides {
              datasetSource
              account_hierarchy
              account
              location_hierarchy
              location
              project_hierarchy
              project
              company_hierarchy
              company
              product_hierarchy
              product
              revgp_hierarchy
              revgp
              datasource_hierarchy
              datasource
              channel_hierarchy
              channel
              costcenter_hierarchy
              costcenter
              costtype
              costpool
              fieldtype
              __typename
            }
            format {
              cellDefault
              __typename
            }
            calculation {
              type
              operands
              __typename
            }
            colKey
            excelLetter
            resolvedScenario
            resolvedPeriod
            __typename
          }
          __typename
        }
        __typename
      }
      columns {
        colKey
        excelLetter
        blockId
        columnNo
        label
        measure
        blockLabel
        blockFootnotes
        groupId
        groupLabel
        groupFootnotes
        scenarioDisplay
        scenarioPeriod
        timeGrain
        nonMaterial
        operator
        operands {
          role
          scenarioToken
          scenario
          periodToken
          period
          yearOffset
          monthOffset
          __typename
        }
        measureOverlays {
          measure
          operator
          operands {
            role
            scenarioToken
            scenario
            periodToken
            period
            yearOffset
            monthOffset
            __typename
          }
          terms {
            role
            operator
            operands {
              role
              scenarioToken
              scenario
              periodToken
              period
              yearOffset
              monthOffset
              __typename
            }
            __typename
          }
          __typename
        }
        format {
          cellDefault
          __typename
        }
        calculation {
          type
          operands
          __typename
        }
        footnotes
        datasetSource
        dimensionOverrides {
          datasetSource
          account_hierarchy
          account
          location_hierarchy
          location
          project_hierarchy
          project
          company_hierarchy
          company
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costcenter_hierarchy
          costcenter
          costtype
          costpool
          fieldtype
          __typename
        }
        __typename
      }
      __typename
    }
    footnotes
    layoutVersion
    templateVersion
    resolvedDeckCycle
    resolvedTemplateCycle
    __typename
  }
}` as GeneratedQuery<
  APITypes.GetPageLayoutQueryVariables,
  APITypes.GetPageLayoutQuery
>;
export const getColumnTemplateCatalog = /* GraphQL */ `query GetColumnTemplateCatalog(
  $userAlias: String
  $deck_id: String!
  $layout_family: String
  $deck_cycle: String
  $grain: String
  $limit: Int
  $nextToken: String
) {
  getColumnTemplateCatalog(
    userAlias: $userAlias
    deck_id: $deck_id
    layout_family: $layout_family
    deck_cycle: $deck_cycle
    grain: $grain
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      pk
      sk
      layout_family
      deck_cycle
      grain
      name
      template_version
      last_updated_by
      last_updated_date
      node_counts {
        groups
        blocks
        leaves
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetColumnTemplateCatalogQueryVariables,
  APITypes.GetColumnTemplateCatalogQuery
>;
